import { createStyles } from "@mantine/core";

const useStyles = createStyles((theme) => ({
  prospectPipelineContent: {
    padding: "12px 8px",
    borderRadius: 16,
    backgroundColor: "#FFF",
    marginTop: 34,
    display: "flex",
    flexDirection: "column",
    gap: 12,
  },
  hdngAndBtn: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    paddingBlock: 5,
    "& > p": {
      margin: 0,
      fontSize: 14,
      fontWeight: 400,
      fontFamily: "Inter",
      color: "#0A0A0A",
    },
  },
  newProspectBtn: {
    padding: "12px 20px",
    borderRadius: "8px",
    border: "1px solid #FFAF4A",
    backgroundColor: "#FFAF4A",
    height: 44,
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
    fontSize: 16,
    fontWeight: 600,
    fontFamily: "Inter",
    color: "#262626",
    ":hover": {
      backgroundColor: "#FFAF4A",
      opacity: 0.8,
    },
  },
  searchInput: {
    flex: 1,
    "& .mantine-Input-input": {
      borderRadius: 8,
      border: "1px solid #D0D5DD",
      boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
      height: "auto",
      fontSize: 14,
      fontWeight: 500,
      fontFamily: "Inter",
      color: "#262626",
    },
  },
  sortByMenu: {
    borderRadius: 8,
    border: "1px solid #D0D5DD",
    backgroundColor: "#F9FAFB",
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
    padding: "8px 14px",
    alignItems: "center",
    gap: 8,
    color: "#1D2939",
    fontSize: 14,
    fontWeight: 600,
    fontFamily: "Inter",
    cursor: "pointer",
  },
  sortByItem: {
    fontFamily: "Inter",
    fontSize: 14,
    fontWeight: 600,
    color: "#262626",
    "&:hover": {
      backgroundColor: "#E5E5E5",
    },
  },
  sortByDropdown: {
    width: "113px !important",
  },
  exportBtn: {
    borderRadius: 8,
    border: "1px solid #D0D5DD",
    backgroundColor: "#F9FAFB",
    fontSize: 14,
    fontWeight: 600,
    color: "#1D2939",
    padding: "8px 14px",
    "&:hover": {
      backgroundColor: "#F9FAFB",
      opacity: 0.8,
    },
  },
  filterRow: {
    alignItems: "center",
    gap: 17,
  },
  table: {
    "& thead > tr > th": {
      padding: "14px 12px",
      fontSize: 14,
      fontWeight: 700,
      fontFamily: "Inter",
      color: "#000",
      borderBottom: "1px solid #E5E5E5",
    },
    "& tbody > tr > td": {
      padding: "14px 12px",
      fontSize: 14,
      fontWeight: 400,
      fontFamily: "Inter",
      color: "#000",
      borderBottom: "1px solid #E5E5E5",
      background: "#fff",
    },
    "& tbody > tr:nth-of-type(even) > td": {
      background: "#F9FAFB",
    },
  },
  tableContainer: {
    borderRadius: "8px",
    border: "1px solid #E5E5E5",
    backgroundColor: "#FFF",
    width: "100%",
  },
  providerInfoTd: {
    "& p": {
      margin: 0,
    },
    "& p:first-child": {
      fontSize: 13,
      fontWeight: 500,
      color: "#0A0A0A",
      fontFamily: "Inter",
    },
    "& p:last-child": {
      fontSize: 11,
      fontWeight: 400,
      color: "#6A7282",
      fontFamily: "Inter",
    },
  },
  status: {
    padding: "0px 8px 0px 6px",
    fontSize: 12,
    fontWeight: 500,
    fontFamily: "Inter",
    color: "#344054",
    height: 22,
    borderRadius: 16,
    backgroundColor: "#F2F4F7",
    textTransform: "capitalize",
    alignItems: "center",
    "& .mantine-Badge-leftSection": {
      display: "flex",
      alignItems: "center",
      paddingBottom: 1,
      marginRight: 4,
      "& svg": {
        color: "#667085",
      },
    },
  },

  greenStatus: {
    color: "#027A48",
    backgroundColor: "#ECFDF3",
    "& .mantine-Badge-leftSection": {
      "& svg": {
        color: "#12B76A",
      },
    },
  },

  blueStatus: {
    color: "#193CB8",
    backgroundColor: "#DBEAFE",
    "& .mantine-Badge-leftSection": {
      "& svg": {
        color: "#193CB8",
      },
    },
  },

  orangeStatus: {
    color: "#9F2D00",
    backgroundColor: "#FFEDD4",
    "& .mantine-Badge-leftSection": {
      "& svg": {
        color: "#9F2D00",
      },
    },
  },

  purpleStatus: {
    color: "#6E11B0",
    backgroundColor: "#F3E8FF",
    "& .mantine-Badge-leftSection": {
      "& svg": {
        color: "#6E11B0",
      },
    },
  },

  filtersTagRow: {
    alignItems: "center",
    gap: 10,
    flexWrap: "wrap",
  },

  filterTag: {
    height: 28,
    padding: "0px 12px",
    border: "1px solid rgba(0, 0, 0, 0.10)",
    borderRadius: 7,
    backgroundColor: "#FFF",
    "& .filterName": {
      fontSize: 13,
      fontWeight: 500,
      fontFamily: "Inter",
      color: "#0A0A0A",
      margin: 0,
    },
    "& .countBox": {
      borderRadius: 6,
      border: "1px solid rgba(0, 0, 0, 0.00)",
      backgroundColor: "#ECEEF2",
      minWidth: 21,
      minHeight: 19,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: 10,
      fontWeight: 500,
      fontFamily: "Inter",
      color: "#030213",
    },
    "& .mantine-Button-label": {
      gap: 10,
    },
    "&:hover": {
      backgroundColor: "#FFF",
      opacity: 0.8,
    },
  },
  activeFilterTag: {
    backgroundColor: "#030213",
    "& .filterName": {
      color: "#FFF",
    },
    "&:hover": {
      backgroundColor: "#030213",
      opacity: 0.8,
    },
  },

  emptyReportsBox: {
    minHeight: 442,
    padding: 41,
    margin: "44px auto",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    borderRadius: 20,
    border: "1px solid #E5E5E5",
    background: "#FFF",
    maxWidth: 761,
    width: "100%",
  },
  iconBox: {
    height: 158,
    width: 158,
    borderRadius: "50%",
    borderTop: "1px solid #D4D4D4",
    background:
      "linear-gradient(180deg, #F1F1F1 0%, rgba(255, 255, 255, 0.00) 81.19%)",
    "& svg": {
      height: 70,
      width: 70,
    },
  },

  notFoundText: {
    color: "#A8A8A8",
    fontFamily: "Inter",
    fontSize: "22px",
    fontStyle: "normal",
    fontWeight: "400",
    lineHeight: "normal",
  },

  notFoundTextContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-evenly",
    height: "75vh",
    gap: "8rem",
  },
  menuDropdown: {
    padding: 8,
    borderRadius: 4,
    backgroundColor: "#FFF",
    boxShadow: "0 2px 8px 0 rgba(0, 0, 0, 0.10)",
  },
  menuDropdownItem: {
    padding: "6px 8px",
    fontSize: 14,
    fontWeight: 600,
    lineHeight: '20px',
    fontFamily: "Inter",
    color: "#262626",
    ":hover": {
      backgroundColor: "#F4F4F5",
      borderRadius: 4,
    },
  },
}));

export default useStyles;
